<template>
  <a-modal
    title="编辑店端配置"
    :visible="visible"
    :width="820"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model
      class="form"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{span: 3}"
      :wrapper-col="{span: 21}"
    >
      <a-form-model-item label="店端配置" prop="storeConfig">
        <a-textarea
          v-model="form.storeConfig"
          :rows="4"
          placeholder="请按需选填，100字以内。"
        />
        <p class="tips">此信息提交后，会更新到【主播档案】作为历史跟踪信息</p>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'StoreConfigModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default () {
        return {}
      }
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rules: {
        storeConfig: [
          { max: 100, message: '最多可输入100字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleOk () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('confirm', { ...this.form })
        } else {
          return false
        }
      })
    },
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  margin-bottom: 0;
  font-size: 12px;
  line-height: 20px;
}
</style>
